<template>
  <div class="our-picks">
    <div class="container">
      <div class="row">
        <div class="slider col col-8">
          <Slider v-if="results.length" class="slider-container" dark>
            <h3 slot="heading" class="h3">
              Our Picks
            </h3>
            <div
              v-for="(articles, index) in results" :key="index" slot="slide"
              class="col col-12"
            >
              <ArticleCard
                v-for="(item, k) in articles" :key="k" :article="item"
                type="horizontal" class="ourpicks"
              />
            </div>
          </Slider>
        </div>
        <div class="side col col-4">
          <div class="side-container">
            <p class="h3">
              Join 2M+ Students
            </p>
            <p class="body-1">
              Start your data science journey for free!
            </p>
            <p class="students">
              <img loading="lazy" src="../../assets/images/users-group-bigger.png" alt="users-group">
            </p>
            <nuxt-link to="/signup/" class="btn-primary btn-lg" data-event="start_your_career1.click">
              Start Now
            </nuxt-link>
            <div class="rating-holder">
              <Rating :scale="4.5" />
              <span class="text">
                <strong>413,000+</strong> Reviews
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import ArticleCard from './ArticleCard';
import Rating from '../Rating';

export default {
  components: { Slider, ArticleCard, Rating },
  mixins: [global],
  props: {
    results: { type: Array, default: () => [], required: true },
  },
};
</script>

<style lang="scss">
.our-picks {
  background-color: var(--main-dark);
  color: var(--main-light);
  padding: var(--spacing-100) 135px var(--spacing-120);
  position: relative;
  z-index: 2;

  .slider {
    padding-right: var(--spacing-55);

    .slider-header {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      padding-bottom: var(--spacing-16);
      margin-bottom: 0;

      .h3 {
        margin: 0;
      }
    }
  }

  .side {
    padding-left: var(--spacing-55);

    .side-container {
      padding: 48px 36px;
      background: var(--main-dark-shade-1);
      border-radius: 7px;

      .h3 {
        margin: 0 0 var(--spacing-16);
        text-align: center;
      }

      .body-1 {
        text-align: center;
        color: var(--main-light-shade-4);
      }

      .students {
        margin-top: 36px;
        margin-bottom: 60px;

        img {
          max-width: 100%;
        }
      }

      .btn-primary {
        width: 100%;
        text-align: center;
      }

      .rating-holder {
        margin-top: var(--spacing-14);
        display: flex;
        flex-wrap: wrap;

        .rating {
          display: flex;
          margin-right: var(--spacing-12);
        }

        .text {
          color: var(--main-light-shade-4);
          opacity: 0.67;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .our-picks {
    padding-left: 0;
    padding-right: 0;

    .slider {
      padding-right: 24px;
    }

    .side {
      padding-left: 24px;
    }
  }
}

@include bp($bp-mobile) {
  .our-picks {
    padding: var(--spacing-80) 0;

    .slider {
      padding-right: 12px;

      .dots .dot {
        margin: 0;
      }
    }

    .side {
      padding-left: 12px;

      .side-container .students img {
        display: block;
        margin: auto;
      }
    }
  }
}
</style>
